import LoadingUserDetailView from './LoadingUserDetailView';

export default LoadingUserDetailView;
